import React from 'react';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';

function Home() {
  const page = "home";
  useEffect(() => {
    // ensure Swiper script is loaded (from CDN in index.html <head>)
    if (!window.Swiper) return;
    const swiper = new window.Swiper('.materials-carousel', {
      speed: 500,
      spaceBetween: 28,
      slidesPerView: 3,
      slidesPerGroup: 1,
      grabCursor: true,
      keyboard: { enabled: true },
      navigation: {
        nextEl: '.materials-carousel .swiper-button-next',
        prevEl: '.materials-carousel .swiper-button-prev',
      },
      pagination: {
        el: '.materials-carousel .swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0:    { slidesPerView: 1 },
        640:  { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });

    return () => swiper?.destroy(true, true);
  }, []);
  return (
    <div>
      {/* <Header /> */}
      {/* <section className="hero"> */}
      <section className={`hero ${page}`}>
        <h1>Global Material Solutions. Local Expertise.</h1>
        <p>From drilling to civil engineering, DMCO delivers high-performance mineral solutions across industries worldwide.</p>
        <div className="scroll-indicator">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 5v14m0 0l-6-6m6 6l6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Scroll down
        </div>
      </section>


      <section className="materials-section" id="materials">
        <div className="container">
          <div className="materials-heading">
            <div className="materials-kicker" aria-hidden="true">Industries We Serve</div>
          </div>

          {/* CAROUSEL */}
          <div className="materials-carousel swiper">
            <div className="swiper-wrapper">

              {/* Slide (repeat for each product) */}
              <div className="swiper-slide">
                <a href="/solutions/oil-gas">
                  <article className="material-card">
                    <div className="thumb">
                      <img src="assets/images/industry/oil-gas.png" alt="Oil Gas Industry" />
                    </div>
                    <h3 className="title">Oil and Gas</h3>
                    <p className="description">
                      Advanced drilling fluids and solutions for optimized exploration and production.
                    </p>
                  </article>
                </a>
              </div>

              <div className="swiper-slide">
                <a href="/solutions/water-well">
                  <article className="material-card">
                    <div className="thumb">
                      <img src="assets/images/industry/water-well.png" alt="Water Well" />
                    </div>
                    <h3 className="title">Water Well</h3>
                    <p className="description">
                      products for enhanced performance and longevity.
                    </p>
                  </article>
                </a>
              </div>

              <div className="swiper-slide">
                <a href="/solutions/automotive">
                  <article className="material-card">
                    <div className="thumb">
                      <img src="assets/images/industry/automotive.png" alt="Automotive" />
                    </div>
                    <h3 className="title">Automotive</h3>
                    <p className="description">
                      High-performance materials for safety-critical components.
                    </p>
                  </article>
                </a>
              </div>

              <div className="swiper-slide">
                <a href="/solutions/civil-sectorl">
                  <article className="material-card">
                    <div className="thumb">
                      <img src="assets/images/industry/civil-sector.png" alt="Civil Sector" />
                    </div>
                    <h3 className="title">Civil Sector</h3>
                    <p className="description">
                      Solutions for soil testing, piling, tunneling, and waterproofing.
                    </p>
                  </article>
                </a>
              </div>

              <div className="swiper-slide">
                <a href="/solutions/steel-industry">
                  <article className="material-card">
                    <div className="thumb">
                      <img src="assets/images/industry/steel-industry.png" alt="Steel Industry" />
                    </div>
                    <h3 className="title">Steel Industry</h3>
                    <p className="description">
                      High-temperature-resistant materials for foundries and steel production.
                    </p>
                  </article>
                </a>
              </div>        
            </div>

            {/* Controls */}
            <div className="swiper-button-prev" aria-label="Previous"></div>
            <div className="swiper-button-next" aria-label="Next"></div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>

      {/*  Maps  Start */}
      <section id="us-sites-map" style={{ padding: '40px 0', background: '#f7f7f7' }}>
        <div className="wrap">
          <svg id="map" viewBox="0 0 975 610" aria-label="US Sites Map"></svg>


          <div id="popup" className="popup" role="dialog" aria-modal="false">
            {/* Title goes on top */}
            <h2 id="p-title" className="popup-title">Location</h2>

            {/* Header now only has the close button */}
            {/* <header>
              <button className="close" aria-label="Close" onClick="hidePopup()">×</button>
            </header> */}

            {/* Content */}
            <div className="content">
              <p id="p-addr"></p>
              <p id="p-email"></p>
              <p id="p-phone">Phone</p>
            </div>

            {/* CTA link */}
            <Link to="/contactUs">
              <div className="cta">
                <span>More info</span><span>→</span>
              </div>
            </Link>
          </div>



          {/* Popup */}
          {/* <div id="popup" className="popup" role="dialog" aria-modal="false">
            <header>
              <div id="p-title">Location</div>
              <button className="close" aria-label="Close" onclick="hidePopup()">×</button>
            </header>
            <div className="content">
              <p id="p-addr"></p>
              <p id="p-phone">Phone</p>
              <p id="p-email"></p>
            </div>
            <Link to="/contactUs">
              <div className="cta">
                <span>More info</span><span>→</span>
              </div>
            </Link>
          </div> */}

          {/* Legend */}
          <div className="legend">
            <span className="hq"><i></i>Warehouse</span>
            <span className="plant"><i></i>Plants</span>
            <span className="glass"><i></i>Partner location</span>
          </div>
        </div>
      </section>
      {/*  Maps End */}      


      <section className="materials-section" id="materials">
      <div className="container">

          {/* Section 1: Heading */}
          <div className="materials-heading">
          <div className="materials-kicker" aria-hidden="true">Why Choose DMCO</div>
          </div>

          {/* Section 2: Grid */}
          <div className="materials-grid">
          {/* Card 1 */}
          <a className="material-card" href="#">
              <div className="thumb">
                <img src="assets/images/icons/record.png" alt="Feldspar" />
              </div>
              <div className="description">
                Proven track record with over 12 years of expertise
              </div>
          </a>

          {/* Card 2 */}
          <a className="material-card" href="#">
              <div className="thumb">
                <img src="assets/images/icons/performance.png" alt="Feldspar" />
              </div>          
              <div className="description">
                Customized, high-performance solutions
              </div>
          </a>

          {/* Card 3 */}
          <a className="material-card" href="#">
              <div className="thumb">
                <img src="assets/images/icons/investment.png" alt="Feldspar" />
              </div>          
              <div className="description">
                Cutting-edge technology investment
              </div>
          </a>

          {/* Card 4 */}
          <a className="material-card" href="#">
              <div className="thumb">
                <img src="assets/images/icons/customer.png" alt="Feldspar" />
              </div>          
              <div className="description">
                Exceptional customer service
              </div>
          </a>

          {/* Card 5 */}
          <a className="material-card" href="#">
              <div className="thumb">
                <img src="assets/images/icons/global.png" alt="Feldspar" />
              </div>          
              <div className="description">
                Strategic global reach
              </div>
          </a>

          {/* Card 5 */}
          <a className="material-card" href="#">
              <div className="thumb">
                <img src="assets/images/icons/sustainability.png" alt="Feldspar" />
              </div>          
              <div className="description">
                Commitment to sustainability, safety and regulatory compilance.
              </div>
          </a>
      </div>
      </div>
      </section>

     {/* <Footer /> */}
    </div>
  )
}

export default Home